import React, { useEffect, useState } from "react";
import Items from "../item/Items";
import "../footerPages.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { link } from "../../../config";
import Logo from "../../../Images/logo.png";

const Conditions = () => {
  const [webConfig, setWebConfig] = useState({});
  const { i18n, t } = useTranslation();

  const getWebConfig = async () => {
    try {
      const { data } = await axios.get(`${link}static-pages`);
      setWebConfig(data);
      console.log(i18n.language);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWebConfig();
  }, []);
  return (
    <div className="d-flex justify-content-center align-content-center container py-3 py-lg-5 mb-3">
      <div className="footer-item p-4 p-lg-5">
        <div className="d-flex justify-content-between align-items-end">
          <img
            alt="Logo"
            style={{ width: "82px", height: "58px" }}
            src={Logo}
          />
        </div>
        <h2 className="text-center my-4">{t("termsAndConditions")}</h2>
        <div
          className="text-center"
          dangerouslySetInnerHTML={{
            __html:
              i18n.language == "en" ? webConfig?.termsEn : webConfig?.termsAr,
          }}
        ></div>
      </div>
    </div>
  );
};

export default Conditions;
